(function () {
  var PANEL_MS = 500;

  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function headerOffset() {
    var raw = getComputedStyle(document.documentElement).getPropertyValue('--header-height');
    var value = parseFloat(raw);
    return Number.isFinite(value) ? value : 56;
  }

  function collapsedItemHeight(root, exclude) {
    var items = root.querySelectorAll('[data-content-stack-item]');
    for (var i = 0; i < items.length; i += 1) {
      var el = items[i];
      if (el === exclude) continue;
      if (el.classList.contains('is-open') || el.classList.contains('is-closing')) continue;
      return el.offsetHeight;
    }
    return 0;
  }

  function scrollToOpened(item, closing, closingHeight, collapsedHeight, reduce) {
    if (!item) return;

    var lift = 0;
    if (
      closing &&
      closing !== item &&
      closingHeight > 0 &&
      collapsedHeight > 0 &&
      (closing.compareDocumentPosition(item) & Node.DOCUMENT_POSITION_FOLLOWING)
    ) {
      lift = Math.max(0, closingHeight - collapsedHeight);
    }

    var top = window.pageYOffset + item.getBoundingClientRect().top - headerOffset() - lift;
    if (top < 0) top = 0;

    window.scrollTo({
      top: top,
      behavior: reduce ? 'auto' : 'smooth',
    });
  }

  function setHits(root) {
    root.querySelectorAll('[data-content-stack-item]').forEach(function (el) {
      var open = el.classList.contains('is-open');
      var hit = el.querySelector('[data-content-stack-hit]');
      if (!hit) return;
      hit.setAttribute('aria-expanded', open ? 'true' : 'false');
      if (open) {
        hit.setAttribute('hidden', '');
      } else {
        hit.removeAttribute('hidden');
      }
    });
  }

  function clearClosing(el) {
    if (el._contentStackCloseTimer) {
      clearTimeout(el._contentStackCloseTimer);
      el._contentStackCloseTimer = null;
    }
    el.classList.remove('is-closing');
  }

  function openItem(root, item) {
    if (!root || !item || item.classList.contains('is-open')) return;
    if (root.querySelectorAll('[data-content-stack-item]').length < 2) return;

    var reduce = prefersReducedMotion();

    root.querySelectorAll('[data-content-stack-item].is-closing').forEach(clearClosing);

    var closing = root.querySelector('[data-content-stack-item].is-open');
    var closingHeight = closing ? closing.offsetHeight : 0;
    var collapsedHeight = collapsedItemHeight(root, closing);

    if (closing) {
      closing.classList.add('is-closing');
      closing.classList.remove('is-open');
      if (reduce) {
        clearClosing(closing);
      } else {
        closing._contentStackCloseTimer = setTimeout(function () {
          closing.classList.remove('is-closing');
          closing._contentStackCloseTimer = null;
        }, PANEL_MS);
      }
    }

    item.classList.add('is-open');
    if (!reduce) root.classList.add('is-animated');
    setHits(root);

    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        scrollToOpened(item, closing, closingHeight, collapsedHeight, reduce);
      });
    });
  }

  document.addEventListener('click', function (event) {
    if (event.target.closest('a')) return;

    var item = event.target.closest('[data-content-stack-item]');
    if (!item) return;

    var root = item.closest('[data-content-stack]');
    openItem(root, item);
  });

  document.addEventListener('shopify:block:select', function (event) {
    var item = event.target && event.target.closest('[data-content-stack-item]');
    if (!item) return;
    openItem(item.closest('[data-content-stack]'), item);
  });
})();
